/* ==========================================================================
   ET - Reveal on scroll (generic, attribute-driven)

   Add attributes in section markup — no selectors are hard-coded here:
     data-et-reveal                -> reveal this element when it enters view
     data-et-reveal="fade|left|right|scale|up"  -> variant (see et-reveal.css)
     data-et-reveal-delay="200"    -> explicit delay (ms)
     data-et-stagger="90"          -> container: reveal its direct children,
                                       one after another (step in ms)

   Failsafe: the CSS only hides things under html.et-reveal-ready. That class
   is added inside a try/catch and removed (revealing everything) if anything
   throws. A watchdog also reveals any element already on screen.
   ========================================================================== */

(function () {
  var docEl = document.documentElement;

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SEL = '[data-et-reveal]';
  var io = null;

  function revealAll() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-revealed');
  }

  /* Watchdog: anything already on screen must never stay hidden. */
  function revealOnScreen() {
    var vh = window.innerHeight || docEl.clientHeight;
    var els = document.querySelectorAll(SEL + ':not(.is-revealed)');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) els[i].classList.add('is-revealed');
    }
  }

  function observe(el, delay) {
    if (!el || el.__etReveal) return;
    el.__etReveal = true;
    if (!el.hasAttribute('data-et-reveal')) el.setAttribute('data-et-reveal', '');
    if (delay) el.style.setProperty('--et-reveal-delay', delay);
    io.observe(el);
  }

  function init(scope) {
    try {
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
      }

      docEl.classList.add('et-reveal-ready');
      /* We took over — cancel the head failsafe so the class (and animation) stays. */
      if (window.__etRevealFailsafe) { clearTimeout(window.__etRevealFailsafe); window.__etRevealFailsafe = null; }
      var root = scope && scope.querySelectorAll ? scope : document;

      /* Stagger containers: reveal their direct children in sequence. */
      root.querySelectorAll('[data-et-stagger]').forEach(function (group) {
        var step = parseInt(group.getAttribute('data-et-stagger'), 10);
        if (isNaN(step)) step = 90;
        var kids = group.children;
        for (var i = 0; i < kids.length; i++) observe(kids[i], i * step);
      });

      /* Standalone reveal elements (already-marked children are skipped). */
      root.querySelectorAll(SEL).forEach(function (el) {
        var d = el.getAttribute('data-et-reveal-delay');
        observe(el, d ? (parseInt(d, 10) || 0) : 0);
      });

      window.setTimeout(revealOnScreen, 1200);
    } catch (err) {
      docEl.classList.remove('et-reveal-ready');
      revealAll();
      if (window.console) window.console.warn('[ET reveal] disabled:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Theme editor: (re)scan a section when it is rendered. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Last-resort watchdog once everything has loaded. */
  window.addEventListener('load', function () { window.setTimeout(revealOnScreen, 800); });
})();
